<!--
 * @FileDescription: 按钮权限模块
 * @Author: 陈文景
 * @Date: 2022-09-22 14:32:37
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="permission-item-box">
    <div class="header">
      <span class="title">{{ title }}</span>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkedAll" @change="handleCheckAllChange">全选</el-checkbox>
    </div>
    <div class="permission-item">
      <el-checkbox-group v-model="backups" @change="handleCheckedPermissionsChange">
        <el-checkbox v-for="permission in permissions" :label="permission" :key="permission">{{ permission }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    permissions: {
      type: Array,
      required: false,
      default: () => []
    },
    // 已选中项
    checkedPermission: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      checkedAll: false, // 是否全选
      isIndeterminate: this.checkedPermission.length > 0 && this.checkedPermission.length < this.permissions.length, // 全选按钮的选中状态
      backups: [...this.checkedPermission] // 备份选中项
    }
  },
  methods: {
    /**
     * 全选按钮的回调事件
     * @param {Boolean} value
     */
    handleCheckAllChange(value) {
      this.isIndeterminate = false
      this.backups = value ? [...this.permissions] : []
      this.$emit('checked', value ? [...this.permissions] : [])
    },

    /**
     * 复选框项的回调事件
     * @param {Array} value 选中项组成的数组
     */
    handleCheckedPermissionsChange(value) {
      let checkedCount = value.length
      this.checkedAll = checkedCount === this.permissions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.permissions.length
      this.$emit('checked', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.permission-item-box {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
  .header {
    display: flex;
    margin-bottom: 5px;
    justify-content: space-between;
    .title {
      font-weight: 700;
    }
  }
  .permission-item {
    padding: 10px;
    border: 1px solid #cdd4dd;
    border-radius: 4px;
  }
}
</style>
